import { useAtomValue } from 'jotai';
import { createFinalSignDocsAtom } from '../../../store/global/atoms/documents-atoms/create-final-consent-sign-docs';

export const useCreateFinalSignDocs = () => {
  const createFinalSignDocs = useAtomValue(createFinalSignDocsAtom);

  return {
    createFinalSignDocsData: createFinalSignDocs.data,
    createFinalSignDocs: createFinalSignDocs.mutate,
    createFinalSignDocsAsync: createFinalSignDocs.mutateAsync,
    error: createFinalSignDocs.error,
    isLoading: createFinalSignDocs.isPending,
  };
};
